import React, { Component } from 'react';
import SystemTranslationStatistic from './SystemTranslationStatistic';
import { browserHistory } from 'react-router';
import { observer } from 'mobx-react';
import SystemTranslationInstructionVideoStatisticService from '../services/SystemTranslationInstructionVideoStatisticService';

class SystemTranslationInstructionVideoStatisticContainer extends Component {
  systemTranslationInstructionVideoStatisticService = new SystemTranslationInstructionVideoStatisticService();

  componentDidMount() {
    this.systemTranslationInstructionVideoStatisticService.load();
  }

  render() {
    return (
      <SystemTranslationStatistic
        title="Instruction Videos"
        icon="video-camera"
        value={this.systemTranslationInstructionVideoStatisticService.summary}
        fetching={this.systemTranslationInstructionVideoStatisticService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/instruction-videos',
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

export default observer(SystemTranslationInstructionVideoStatisticContainer);
